import React, { Component } from "react";
import { connect } from "react-redux";
import { isMobile } from 'react-device-detect';
import ClientWrapper from './Client.style';
import {
  setClientValue,
  setHomeValue,
} from "../../../actions";
import { options } from "../../../operations";
import { getStreetsAsync } from '../../../operations/options';
import { Body, Text, InputCleave } from '../Form';
import { Select, Input, AsyncSelect } from '../../ui';
import Continue from "../Continue";
import {
  validateEmail,
  mapSelectList,
  getAge, ageBetween
} from "../../../helpers";

import iconUser from '../../../assets/icons/icon-user.svg';
import iconEmail from '../../../assets/icons/icon-email.svg';
import iconCalendar from '../../../assets/icons/icon-calendar-blue.svg';
import iconGender from '../../../assets/icons/icon-gender.svg';
import iconNumber from '../../../assets/icons/icon-number.svg';
import homeIcon from '../../../assets/icons/icon-house.svg';

class ClientData extends Component {

  constructor(props) {
    super(props);
    this.state = { continue: false };
    this.continueCondition = this.continueCondition.bind(this);
    this.getContent = this.getContent.bind(this);
  }

  componentDidMount() {
    const { getDepartments } = this.props;
    this.checkContinueState(null);
    getDepartments();
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkContinueState(prevState);
  }

  continueCondition() {

    const { 
      name, lastName, lastName2,
      documentType, documentNumber, 
      cellPhoneNumber,
      email, birthDate, gender, 
      addressState, addressCity, 
      addressStreet, addressNumber
    } = this.props;

    return (
      name && lastName && lastName2 &&
      documentType && documentNumber &&
      cellPhoneNumber && 
      //cellPhoneNumber.length >= 8 &&
      //cellPhoneNumber.length <= 9  &&
      email && validateEmail(email) && 
      birthDate && gender && 
      birthDate.length === 10 &&
      ageBetween(getAge(birthDate), 18, 150) &&
      addressState != null &&
      addressCity != null &&
      addressStreet != null &&
      addressNumber != ''
    );
  }

  checkContinueState(prevState) {
    if (this.continueCondition()) {
      if (prevState === null || !prevState.continue) this.setState({ continue: true });
    } else {
      if (prevState === null || prevState.continue) this.setState({ continue: false });
    }
  }

  getContent() {

    const { 
      showError, onValueChange, 
      onDepartmentChange, onCityChange, 
      getStreets, onStreetChange,
      genders, documentTypes, 
      departments, cities, streets
    } = this.props;

    const { 
      name, lastName, lastName2,
      documentType, documentNumber, 
      cellPhoneNumber, phoneNumber,
      email, birthDate, gender, 
      addressState, addressCity, 
      addressStreet, addressNumber
    } = this.props;

    return (
      <>
        <div className="Client-formRow Client-formRow-1">
          <div style={{ flex: 1 }}>
            <Input
              id="name"
              name="name"
              placeholder="Nombre (*)"
              maxLength="50"
              type="text"
              value={name}
              onChange={(event) => { onValueChange('name', event.target.value) }}
              leftIcon={iconUser}
              showAlert={showError && !name}
              autoComplete="nope"
            />
          </div>
          <div style={{ flex: 1 }}>
            <Input
              id="email"
              name="email"
              placeholder="Email (*)"
              maxLength="50"
              type="email"
              value={email}
              onChange={(event) => { onValueChange('email', event.target.value) }}
              leftIcon={iconEmail}
              showAlert={showError && !validateEmail(email)}
              autoComplete="nope"
            />
          </div>
        </div>
        <div className="Client-formRow Client-formRow-1">
          <div style={{ flex: 1 }}>
            <Input
              id="lastName"
              name="lastName"
              placeholder="Apellido paterno (*)"
              maxLength="50"
              type="text"
              value={lastName}
              onChange={(event) => { onValueChange('lastName', event.target.value) }}
              leftIcon={iconUser}
              showAlert={showError && !lastName}
              autoComplete="nope"
            />
          </div>
          <div style={{ flex: 1 }}>
            <InputCleave
              name="birthDate"
              placeholder="Fecha de nacimiento (*)"
              value={birthDate}
              leftIcon={iconCalendar}
              showAlert={
                showError && (!birthDate || !birthDate.length === 10 ||
                !ageBetween(getAge(birthDate), 18, 150))
              }
              options={{date: true, datePattern: ['d','m','Y']}}
              onChange={(event) => { onValueChange('birthDate', event.target.value) }}
            />
          </div>
        </div>
        <div className="Client-formRow Client-formRow-1">
          <div style={{ flex: 1 }}>
            <Input
              id="lastName2"
              name="lastName2"
              placeholder="Apellido materno (*)"
              maxLength="50"
              type="text"
              value={lastName2}
              onChange={(event) => { onValueChange('lastName2', event.target.value) }}
              leftIcon={iconUser}
              showAlert={showError && !lastName2}
              autoComplete="nope"
            />
          </div>
          <div style={{ flex: 1 }}>
            <Select
              id="gender"
              name="gender"
              placeholder="Seleccione su sexo (*)"
              leftIcon={iconGender}
              value={genders.find(g => g.value === gender)}
              showAlert={showError && !gender}
              onChange={(event) => { onValueChange('gender', event.value) }}
              searchable={!isMobile}
              options={genders}
              autoComplete="nope"
            />
          </div>
        </div>
        <div className="Client-formRow Client-formRow-1">
          <div style={{ flex: 1 }}>
            <Select
              id="documentType"
              name="documentType"
              placeholder="Seleccione tipo de documento (*)"
              leftIcon={iconNumber}
              value={documentTypes.find(dt => dt.value === documentType)}
              showAlert={showError && !documentType}
              onChange={(event) => { onValueChange('documentType', event.value) }}
              searchable={!isMobile}
              options={documentTypes}
              autoComplete="nope"
            />     
          </div>
          <div style={{ flex: 1 }}>
            <Select
              id="depto"
              leftIcon={homeIcon}
              name="depto"
              placeholder="Seleccione un departamento (*)"
              value={addressState}
              showAlert={showError && !addressState}
              onChange={onDepartmentChange}
              options={mapSelectList(departments)}
            />
          </div>
        </div>
        <div className="Client-formRow Client-formRow-1">
          <div style={{ flex: 1 }}>
            <Input
              id="documentNumber"
              name="documentNumber"
              placeholder="N° de documento (*)"
              maxLength="50"
              type="text"
              value={documentNumber}
              onChange={(event) => { onValueChange('documentNumber', event.target.value) }}
              leftIcon={iconNumber}
              showAlert={showError && !documentNumber}
              autoComplete="nope"
            />     
          </div>
          <div style={{ flex: 1 }}>
            <Select
              id="city"
              leftIcon={homeIcon}
              name="city"
              placeholder="Seleccione una ciudad (*)"
              value={addressCity}
              showAlert={showError && !addressCity}
              onChange={onCityChange}
              options={mapSelectList(cities)}
              noOptionsMessage={() => "Sin ciudades. Seleccione el Departamento primero."}
              loadingMessage={() => "Cargando.."}
            />
          </div>
        </div>
        <div className="Client-formRow Client-formRow-1">
          <div style={{ flex: 1 }}>
            <Input
              id="phoneNumber"
              name="phoneNumber"
              placeholder="Teléfono"
              maxLength="50"
              type="text"
              value={phoneNumber}
              onChange={(event) => { onValueChange('phoneNumber', event.target.value) }}
              leftIcon={iconNumber}
              showAlert={showError && !phoneNumber}
              autoComplete="nope"
            />
          </div>
          <div style={{ flex: 1 }}>
            <AsyncSelect
              id="address"
              leftIcon={homeIcon}
              name="calle"
              value={addressStreet}
              onChange={onStreetChange}
              placeholder="Seleccione una calle (*)"
              loadOptions={(inputValue) => getStreetsAsync(addressState, addressCity, inputValue)}
              // cacheOptions
              showAlert={showError && !addressStreet}
              disabled={addressCity === null}
              noOptionsMessage={() =>
                'Sin calles. Seleccione el Departamento y la Ciudad primero, y comience a escribir el nombre'
              }
              loadingMessage={() => 'Cargando...'}
            />
          </div>
        </div>
        <div className="Client-formRow Client-formRow-1">
          <div style={{ flex: 1 }}>
            <Input
              id="cellPhoneNumber"
              name="cellPhoneNumber"
              placeholder="Celular (*)"
              maxLength="50"
              type="text"
              value={cellPhoneNumber}
              onChange={(event) => { onValueChange('cellPhoneNumber', event.target.value) }}
              leftIcon={iconNumber}
              showAlert={showError && !cellPhoneNumber}
              autoComplete="nope"
            />
          </div>
          <div style={{ flex: 1 }}>
            <Input
              id="addressNumber"
              name="addressNumber"
              placeholder="Nro. de puerta, manzana, solar (*)"
              maxLength="50"
              type="text"
              value={addressNumber}
              onChange={(event) => { onValueChange('addressNumber', event.target.value) }}
              leftIcon={homeIcon}
              showAlert={showError && !addressNumber}
              autoComplete="nope"
            />          
          </div>
        </div>
      </>
    );
  }

  render() {

    const { continue: toContinue } = this.state;

    return (
      <ClientWrapper>
        <Text style={{ paddingTop: '25px'}} className="Text-question">
          Confirma tus datos personales
        </Text>
        <Body columnContent={this.getContent} />
        <Continue state={toContinue}/>
      </ClientWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    showError: state.steps.showError,

    name: state.client.name,
    lastName: state.client.lastName,
    lastName2: state.client.lastName2,
    documentType: state.client.documentType,
    documentNumber: state.client.documentNumber,
    cellPhoneNumber: state.client.cellPhoneNumber,
    phoneNumber: state.client.phoneNumber,
    
    email: state.client.email,
    birthDate: state.client.birthDate,
    gender: state.client.gender,
    addressState: state.client.addressState,
    addressCity: state.client.addressCity,
    addressStreet: state.client.addressStreet,
    addressNumber: state.client.addressNumber,

    genders: state.options.genders,
    documentTypes: state.options.documentTypes,
    departments: state.options.departments,
    cities: state.options.cities,
    streets: state.options.streets,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onValueChange: (type, value) => {
      dispatch(setClientValue(type, value));
    },
    getDepartments: () => {
      dispatch(options.getDepartments());
    },
    onDepartmentChange: (addressState) => {
      dispatch(options.setDepartment(addressState));
    },
    onCityChange: (addressCity) => {
      dispatch(options.setCity(addressCity));
    },
    getStreets: (val, callback) => {
      dispatch(options.getStreets(val, callback));
    },
    onStreetChange: (addressStreet) => {
      dispatch(setClientValue('addressStreet', addressStreet));
    },
    
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientData);